import React from 'react'

import { Field } from 'formik'

import { Col, Form } from '_zari/core'

import { TiposDeDocumentosRelacionadosCuentaContableConstant } from 'constants/index'

import * as CuentaContableService from 'services/cuentaContable.service'

const CuentaFormGroup = ({ idFormato, iTouched, iError, fIsSubmitting, name, label }) => {
  const [cuentasContablesBanco, setCuentasContablesBanco] = React.useState([])

  React.useEffect(() => {
    CuentaContableService.getCuentaContablexTipoDocumentoxPrefijoCuenta({
      tipoDocumento: TiposDeDocumentosRelacionadosCuentaContableConstant.BANCOS,
      prefijoCuenta: '104'
    }).then(({ data }) => {
      setCuentasContablesBanco(data)
    })
  }, [])

  return (
    <Form.Group>
      <Form.Label text={label || 'CUENTA'} htmlFor={`${idFormato}-input-mesContabilidad`} md={4} alignRightAt='md' />
      <Col md={8}>
        <Field name={name || 'cuenta'}>
          {({ field }) => (
            <Form.Select id='select-cuenta' fIsSubmitting={fIsSubmitting} iError={iError} iTouched={iTouched} {...field}>
              <option value=''>Seleccionar</option>
              {cuentasContablesBanco.map(x => (
                <option key={x._id} value={x.codigoCuenta}>
                  {`${x.codigoCuenta} - ${x.descripcion}`}
                </option>
              ))}
            </Form.Select>
          )}
        </Field>
        {iTouched && iError ? <Form.Feedback type='invalid'>{iError}</Form.Feedback> : null}
      </Col>
    </Form.Group>
  )
}

export default React.memo(CuentaFormGroup)
